<template>
	<div class="expandable-card" :class="{ 'is-card-open': model.isOpen }">
		<div class="card-header" @click="$emit('openPlacement', model.key)">
			<Carret class="carret-icon" :class="{ 'is-open': model.isOpen }" />Placement {{ model.key + 1 }}
		</div>
		<div class="card-body" v-show="model.isOpen">
			<div class="visible-section">
				<transition name="fromBottomMenu" mode="out-in">
					<div>
						<CombinedInputFieldDataMenu
							:prefixStyle="prefixStyle"
							:suffixStyle="suffixStyle"
							:value.sync="localValue"
							:mode="2"
							:options="items"
							:nodeId="selectedNodeId"
						/>
					</div>
				</transition>
				<SwitchOption class="title-section" option-name="Title" :switch-model.sync="localTitleEnabled" />
				<v-text-field v-model="localTitleValue" v-show="localTitleEnabled" outlined dense />
			</div>
			<div class="hidden-section"></div>
		</div>
	</div>
</template>

<script>
import { flatten } from '@/utils/helpers';

import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';
import SwitchOption from '../FieldOptions/SwitchOption.vue';

import Carret from '../../assets/caret.svg';

export default {
	name: 'ExpandableCard',
	props: {
		model: { type: Object },
		row: { type: Object },
		prefixStyle: { type: Object },
		suffixStyle: { type: Object },
		selectedNodeId: { type: Number },
	},
	components: {
		CombinedInputFieldDataMenu,
		Carret,
		SwitchOption,
	},
	computed: {
		localCard: {
			set(value) {
				this.$emit('updateValue', { key: this.model.key, value });
			},
			get() {
				return this.model.data;
			},
		},
		localValue: {
			set(value) {
				this.localCard = Object.assign({}, { ...this.localCard }, { value });
			},
			get() {
				return this.localCard?.value;
			},
		},
		localTitle: {
			set(value) {
				this.localCard = Object.assign({}, { ...this.localCard }, { title: value });
			},
			get() {
				return this.localCard.title || {};
			},
		},
		localTitleEnabled: {
			set(value) {
				this.localTitle = Object.assign({}, { ...this.localTitle }, { enabled: value });
			},
			get() {
				return this.localTitle.enabled || false;
			},
		},
		localTitleValue: {
			set(value) {
				this.localTitle = Object.assign({}, { ...this.localTitle }, { value });
			},
			get() {
				return this.localTitle.value || '';
			},
		},
		flatItems() {
			return flatten(this.row);
		},
		items() {
			const items = [];
			for (const [key, value] of Object.entries(this.flatItems)) {
				items.push({ key, example: value });
			}
			return items;
		},
	},
	methods: {},
};
</script>

<style scoped lang="scss">
.expandable-card {
	border: 1px solid #d1d9e9;
	border-radius: 6px;
	overflow: hidden;

	&.is-card-open {
		border: var(--bold-border);

		.card-header {
			color: #6e99f6;
			::v-deep path {
				stroke: #6e99f6;
			}
		}
	}
	.card-header {
		padding: 6px 10px;
		background-color: #f1f5f8;
		color: #4e4d4e;
		transition: 0.3s;

		.carret-icon {
			margin: 0 10px 0 0;
			transition: 0.3s;

			&.is-open {
				transform: rotate(90deg);
				transition: 0.3s;
			}
		}
		&:hover {
			transition: 0.3s;
			filter: brightness(0.97);
			cursor: pointer;
		}
	}
	.card-body {
		padding: 10px 10px 4px 10px;

		.title-section {
			margin: 15px 0 0 0;
		}

		::v-deep {
			.title-section {
				margin-top: 10px;
			}
			.mb-4 {
				margin-bottom: 6px !important;
			}
		}
	}

	::v-deep {
		.data_input_card {
			overflow: scroll;
		}
	}
}
</style>
